import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import ListDisplay from "../navBar/subMenuListDisplay";
import PageSettings from "./files/pageSettings";

function PodRouter(props) {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/list" element={<ListDisplay section="pages" items={props.items} />} />
                        <Route path="/settings/:id" element={<PageSettings />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
